import React, { useEffect, useState,useRef } from "react";
import { useParams,useNavigate } from "react-router-dom";
import ChatSidebar from "../../components/v1/ChatSidebar";
import Chat from "../../components/v1/Chat";
import NotFound from '../../components/NotFound';
import { fetchKaiConfig,authorize, loadVirtualAssiatant, fetchChatHistory,fetchChatmessages, deleteChat,decryptBypasstoken , fetchInputMsgCount} from '../../services/api/KaiConfigData';
import { FaBars, FaPlus, FaSignOutAlt, FaInfoCircle  } from "react-icons/fa";
import DeleteConfirmationModal from '../../components/DeleteConfirmationModal';
import { isLightColor } from "../../utils//LuminosityChecker";
import { darkenColor } from "../../constants/darkenColor";
import { lightenColor } from "../../constants/lightenColor";
import { useLocation } from 'react-router-dom';
import { PublicClientApplication,AuthenticationResult,AccountInfo  } from "@azure/msal-browser";
import { useMsal } from "@azure/msal-react";
import { EventType, EventMessage,InteractionStatus  } from "@azure/msal-browser"; 
import { msalConfig,loginRequest } from "../../config/authConfig";
import { validateAdLogin } from '../../services/api/authenticate';

interface ConnectionResponse {
  message: string;
  data: any;
  error: any;
  authorised: any;
  has_error: any;
  is_authorized: any
}

type Message = {
  sender: 'user' | 'assistant';
  message: string;
  message_id?: string;
};

type ChatData = {
  id: string;
  created_at: string;
  title: string;
  messages: Message[];
};

const ChatAssistantWrapper: React.FC = () => {
  
  const { app_id } = useParams();
  const { instance: msalInstance, accounts, inProgress } = useMsal();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const preview = params.get('preview');
  const bypassToken = params.get('bypasstoken');
  // const accounts = msalInstance.getAllAccounts();
  const [accessToken, setAccessToken] = useState<string | null>(null);
  const [apiResponse, setApiResponse] = useState(null);

  const navigate = useNavigate(); 

  const [chats, setChats] = useState<ChatData[]>([]);
  const [activeChatId, setActiveChatId] = useState<string | null>(null);
  const [isValidApp, setIsValidApp] = useState<boolean | null>(null);
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [errorTitle, setErrorTitle] = useState<string>("");
  const [configData, setConfigData] = useState<any>(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isModalOpen, setModalOpen] = useState(false);
  const [selectedChatId, setSelectedChatId] = useState<string | null>(null);
  const [headerColor, setheaderColor] = useState<string | null>(null);
 
  const [decryptedUser, setDecryptedUser] = useState('');
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userDetails, setUserDetails] = useState<AccountInfo | null>(null);
  const [netId, setNetId] = useState(localStorage.getItem("net_id") || "");
  const [bypassMode, setBypassMode] = useState<boolean | null>(null);
  const [noAuth, setNoAuth] = useState<boolean | null>(false);

 

  const [userMsgCount, setUserMsgCount] = useState<number | 0>(0);
  const [pendingMsgCount, setPendingMsgCount] = useState<number | 0>(0);

  const [everyOneChecked, setEveryOneChecked] = useState(false);

  const [allowSendMsg, setAllowSendMsg] = useState(true);
  const [showCustomLoginPage, setShowCustomLoginPage] = useState(false);

  // Theme state for v1 components
  const [themeOverride, setThemeOverride] = useState<'light' | 'dark' | 'auto'>('auto');

  
  const handleLogout = async () => {
    const LOGOUT_REDIRECT_URL = process.env.REACT_APP_URL;
    localStorage.removeItem('net_id');
    setNetId('');
    const isInIframe = window.self !== window.top;
    if (isInIframe) {
      msalInstance.logoutPopup({
        postLogoutRedirectUri: `${LOGOUT_REDIRECT_URL}/${app_id}`,
      })
    }
    else{
      msalInstance.logoutRedirect({
        postLogoutRedirectUri: `${LOGOUT_REDIRECT_URL}/${app_id}`,
      });
    }
  };

  // Trigger loginRedirect() on component mount (or based on your condition)
  const handleLogin = async () => {
    if (!msalInstance || !msalInstance.getAllAccounts) {
      return;
    }
    const isInIframe = window.self !== window.top;
    
    if (accounts.length === 0) {
      try {
        
        if (isInIframe) {
          msalInstance
          .loginPopup({
            scopes: ["user.read"],
          })
          .then((response) => {
            checkLoginStatus();
          })
          .catch((error) => {
            // console.error("Login failed:", error);
          });
        }
        else{
          // console.log("Running in iframe else?", isInIframe);
          await msalInstance.loginRedirect({
            scopes: ["user.read"], // Modify with appropriate scopes
          });
        }
      } catch (error) {
        console.error("Login failed:", error);
      }
    }
  };
  
  const handleSelectChat = async (id: string) => {
    //fetch Chat details
    if(id){
      try{
          const chatMessage = await fetchChatmessages(app_id || '', localStorage.getItem('net_id') || '',id);
          const formattedMessages: Message[] = chatMessage.messages.map((msg: any) => ({
            sender: msg.sender,
            message: msg.message,
            message_id: msg.message_id,
            isRefAvailable: msg.isRefAvailable,
          }));

          setActiveChatId(id);
          // Replace messages instead of appending
        setChats((prevChats) =>
          prevChats.map((chat) => 
            chat.id === id 
              ? { ...chat, messages: formattedMessages }  // Overwrite messages
              : chat
          )
        );
      }
      catch(error){
        setIsValidApp(false);
          setErrorMessage("Unknown error");
          setErrorTitle("Unknown error");
      }
    
      }
      else{
        const newChat: ChatData = {
          id: 'chat', // Assign a new unique ID
          created_at: new Date().toISOString(), // Current date
          messages: [],
          title: 'chat',
        };
    
        setChats((prevChats) => {
          const updatedChats = [...prevChats, newChat];
          setActiveChatId(newChat.id); // Set the newly created chat as active
          return updatedChats;
        });
      }
  };

  const handleNewChat = () => {
    const existingNullChat = chats.find(chat => chat.id === 'chat');
    if (existingNullChat) {  
      setActiveChatId(existingNullChat.id);  // Set the existing empty chat as active
    }
    else{
    // Create a new chat if no active chat, else add a message to the active chat
    const newChat: ChatData = {
      id: 'chat', // Assign a new unique ID
      created_at: new Date().toISOString(), // Current date
      messages: [],
      title: 'chat',
    };
    setChats((prevChats) => {
      const updatedChats = [...prevChats, newChat];
      setActiveChatId(newChat.id); // Set the newly created chat as active
      return updatedChats;
    });
  }
  };

  const checkLoginStatus = async () => {
      const response = await msalInstance.handleRedirectPromise(); // important!
      if (response && response.account) {
        msalInstance.setActiveAccount(response.account);
      }
      const currentAccounts = msalInstance.getAllAccounts();
      //  handleLogout();
      // console.log("checkLoginStatus***")
      // console.log(currentAccounts)
      if (currentAccounts.length > 0) {
          // If there is an active session, set the user details

          setIsLoggedIn(true);
          setUserDetails(currentAccounts[0]);
          const emailid = currentAccounts[0]?.username
          const netid = emailid.split("@")[0];
          localStorage.setItem('net_id', netid);
          localStorage.setItem('username', currentAccounts[0]?.name ?? '');
          localStorage.setItem('email', currentAccounts[0]?.username ?? '');
          setNetId(localStorage.getItem("net_id") || "");
          //check netid is part of the localuser/ canvas user by calling backend api
          authorizeNetId();
      } else {
        localStorage.removeItem('username');
        localStorage.removeItem('email');
        // If no active session, initiate login
        handleLogin();
      }
};

useEffect(() => {
  const isBypass = !!(preview && bypassToken);
  setBypassMode(isBypass);
  const TOKEN_KEY = 'VAB25J040312';

  const decryptToken = async () => {
    if (bypassToken) {
      const result = await decryptBypasstoken(bypassToken, TOKEN_KEY);
      if (result && result.decrypted_data === TOKEN_KEY) {
        await loadVA(); // ✅ Directly load the assistant
        setAllowSendMsg(true)
        setPendingMsgCount(500)
        return true;
      }
    }
    console.log('V1: No valid bypass token, proceeding with normal auth');
    return false;
  };

  const initialize = async () => {
    const isBypassed = await decryptToken();

    if (!isBypassed) {
      // ✅ Only now initialize Azure login
      try {
        await validateAppId(); // or checkLoginStatus() if needed
      } catch (error) {
        console.error("V1: MSAL Initialization Failed:", error);
        setIsValidApp(false);
        setErrorTitle('msal-init-error');
        setErrorMessage('Failed to initialize authentication: ' + error);
      }
    }
  };

  initialize();
}, [app_id, location.search]);


    
const authorizeNetId = async () => {
    const net_id = localStorage.getItem('net_id') || '';
    let result: ConnectionResponse;
    result = await authorize(app_id || '', net_id);
    if (result.has_error) {
      setIsValidApp(false);
      setErrorMessage(result.message || "Unknown error");
      setErrorTitle(result.error || "Unknown error");
    }
    else if(result.is_authorized){
      setIsValidApp(true);
      //here get the is_authentication_enabled
    }
    else if(!result.is_authorized){
      setIsValidApp(false);
      setErrorTitle('unauthorised');
    }
}
const validateAppId = async () => {
      const net_id = localStorage.getItem('net_id') || '';

      let result: ConnectionResponse;
      if (decryptedUser) {
        result = await loadVirtualAssiatant(app_id || '');
      } else {
        //here no need to pass netid as just to check authentication details
        result = await fetchKaiConfig(app_id || '', net_id);
        const userMsgCount = await fetchInputMsgCount(localStorage.getItem("net_id") || "",app_id || "");
        setUserMsgCount(userMsgCount)

        //set pending Msg count
        const pendingCount = parseFloat(result.data?.messages_per_month_limit || "0") - (userMsgCount ?? 0);
        // const pendingCount = 110 - (userMsgCount ?? 0);
        setPendingMsgCount(pendingCount)
        if(pendingCount <= 0){
          setAllowSendMsg(false)
        }
        else{
          setAllowSendMsg(true)
        }
        
        if (result.has_error) {
          setIsValidApp(false);
          setErrorMessage(result.message || "Unknown error");
          setErrorTitle(result.error || "Unknown error");
        } else {
          const is_authentication_enabled = result.data?.is_authentication_enabled;        
          if(String(is_authentication_enabled) === 'true'){
              //then check either canvas user/local user checked
              const is_everyone_checked = String(result?.data.is_everyone) === 'true';
              const is_canvas_checked = String(result?.data.canvas_user_enabled) === 'true';
              const is_localuser_checked = String(result?.data.local_user_enabled) === 'true';
              if(is_everyone_checked)
                setEveryOneChecked(true)
              else  
                setEveryOneChecked(false)
                
              const currentAccounts = msalInstance.getAllAccounts();   
              if ((inProgress === 'startup' || inProgress === 'none') && (is_everyone_checked || is_canvas_checked || is_localuser_checked)) {
                setConfigData(result.data);
                checkLoginStatus();
              }
              else{
                setIsValidApp(false);
                setErrorTitle('unauthorised');
              }

          }
          else{
                //create dummy user
                setNoAuth(true);
                const dummyUserId = generateDummyUserId(app_id);
                localStorage.setItem('net_id', dummyUserId);
                setNetId(localStorage.getItem("net_id") || "");
                setIsValidApp(true);
                //here get the is_authentication_enabled
                setConfigData(result.data);
            }
          } 
          // else {
          //   setIsValidApp(false);
          //   setErrorMessage(result.message || "Unauthorized access.");
          //   setErrorTitle(result.error || "Unknown error");
          // }
        }
    };
    //for all type of user for ifram
    const loadVA = async () => {
      let result: ConnectionResponse | null = null; // Initialize with null
      result = await loadVirtualAssiatant(app_id || '');
      
      if (result && result.has_error) {
        setIsValidApp(false);
        setErrorMessage(result.message || "Unknown error");
        setErrorTitle("not-saved");
      } else if (result?.authorised) {
        setIsValidApp(true);
        setConfigData(result.data);
        //added this to display new chat defaultly on load
        if(preview && bypassToken){
          if(activeChatId === 'chat' || activeChatId === null){
            let activeChats = chats.find((chat) => chat.id === activeChatId);
            if(!activeChats)
              handleNewChat()
          }
        }
      } else {
      setIsValidApp(false);
      setErrorMessage(result?.message || "Unauthorized access.");
      setErrorTitle(result?.error || "Unknown error");
      }
    };

    useEffect(() => {
      // console.log("DEcrypted user is:");
      //  console.log("userMsgCount"+userMsgCount)
    },[decryptedUser,userMsgCount, pendingMsgCount, allowSendMsg, everyOneChecked]);


    useEffect(() => {
      // console.log("Netid:");
      // console.log(netId)
    },[netId]);

    useEffect(() => {
      // console.log("No Auth:");
      // console.log(noAuth)
    },[noAuth]);
    
  
    const handleSendMessage = async (newMessage: Message, aChatId: string, idFromResp: string) => {   
      // Determine which chat should be active
      const newActiveChatId = idFromResp || aChatId;
    
      // First update messages in chats
      setChats((prevChats) => {
        const updatedChats = prevChats.map((chat) => {
          if (chat.id === aChatId || (idFromResp && chat.id === 'chat')) {
            return {
              ...chat,
              id: idFromResp || chat.id,
              messages: [...chat.messages, newMessage],
            };
          }
          return chat;
        });
      
        // Check if the updated chat ID already exists (e.g., from another chat)
        const chatIds = new Set();
        const deduplicatedChats: ChatData[] = [];
        for (const chat of updatedChats) {
          if (!chatIds.has(chat.id)) {
            chatIds.add(chat.id);
            deduplicatedChats.push(chat);
          }
        }
      
        return deduplicatedChats;
      });
      // Then set only one chat as active
      setActiveChatId(newActiveChatId);
      //fetch user chat count
      
      setTimeout(async () => {
        const userMsgCount = await fetchInputMsgCount(localStorage.getItem("net_id") || "", app_id || "");
        setUserMsgCount(userMsgCount);
        const pendingCount = parseFloat(configData?.messages_per_month_limit || "0") - (userMsgCount ?? 0);
        // const pendingCount = 110 - (userMsgCount ?? 0);
        setPendingMsgCount(pendingCount)
        if(pendingCount <= 0){
          setAllowSendMsg(false)
        }
        else{
          setAllowSendMsg(true)
        }
      }, 6000); // First call after 15 seconds
      
      // setTimeout(async () => {
      //   const userMsgCount = await fetchInputMsgCount(localStorage.getItem("net_id") || "", app_id || "");
      //   setUserMsgCount(userMsgCount);
      //   // const pendingCount = parseFloat(configData?.messages_per_month_limit || "0") - (userMsgCount ?? 0);
      //   const pendingCount = 105 - (userMsgCount ?? 0);
      //   setPendingMsgCount(pendingCount)
      // }, 10000); // Second call after 25 seconds (10 seconds after the first)
      
    };
    
  useEffect(() => {
    // Find the active chat
    if (preview && bypassToken) return;
    else{
      const activeChat = chats.find((chat) => chat.id === activeChatId);
      
      // Fetch history only if title is "chat"
      if (activeChat?.title === "chat" && activeChat?.id !== "chat" && activeChatId && activeChat !== undefined) {  
          const loadUpdatedChats = async () => {
              const updatedChats = await fetchChatHistory(app_id || "", localStorage.getItem("net_id") || "");
              // Find the chat with the matching ID
              const chatHistory: ChatData[] = updatedChats.chat_history.history as ChatData[];
              
              const matchedChat = chatHistory.find((chat: ChatData) => chat.id === activeChatId);

              if (matchedChat) {
                // Update only the title of the matched chat in the chats state
                setChats(prevChats =>
                  prevChats.map((chat: ChatData) =>
                    chat.id === activeChatId ? { ...chat, title: matchedChat.title } : chat
                  )
                );
              }
            };
         
            const timeoutId = setTimeout(() => {
              loadUpdatedChats();
            }, 2000);
            // return () => clearTimeout(timeoutId);
      // handleSelectChat(activeChatId || '');
      }
  }
  
    
  }, [activeChatId]); // Runs only when activeChatId changes
  // Runs when activeChatId changes
  
  useEffect(() => {
    // console.log("Updated Chats:", chats);
  }, [chats,setheaderColor]);

  useEffect(() => {
    const loadChats = async () => {
      try{
      const chatData = await fetchChatHistory(app_id || '', netId || '');
      
      const data = chatData.chat_history.history;
  
      const formattedChatData: ChatData[] = data.map((chat: any) => ({ // Explicitly typing the 'chat' parameter
        ...chat,
        messages: (chat.messages || []).map((message: any) => ({
          ...message,
          role: message.role === 'user' || message.role === 'assistant' ? message.role : 'user',
        })),
      }));

  
      setChats(formattedChatData);
    }
    catch(error){
      setIsValidApp(false);
        setErrorMessage("Unknown error");
        setErrorTitle("Unknown error");
    }
  
      // if (formattedChatData.length > 0) {
      //   setActiveChatId(formattedChatData[0].id); // Set the first chat as active, if available
      // }
      // else {
        handleNewChat(); // Create a new chat if no existing chats are found
      // }
    };
    if (!netId) return;
    if(preview && bypassToken){
      setChats([]);
      return;
    }
    else{
      loadChats();
    }
  }, [app_id,netId]); // This will only run on app_id change

  const updateChatHistory = async (app_id: string, net_id: string, chat_id: string, type?: string) => {
    try {
      // Fetch updated chat history from the API
      const chatData = await fetchChatHistory(app_id, net_id);
      const data = chatData.chat_history.history;
      if(data){
      // Format the fetched chat data
          const formattedChatData: ChatData[] = data.map((chat: any) => ({
            ...chat,
            messages: (chat.messages || []).map((message: any) => ({
              ...message,
              role: message.role === 'user' || message.role === 'assistant' ? message.role : 'user',
            })),
          }));
          // Update the state with the formatted chat data
          setChats(formattedChatData);
          if(type !== 'Delete'){
            setActiveChatId(chat_id);
            handleSelectChat(chat_id);
          }
          else{
            setTimeout(() => {
              handleNewChat();
            }, 100); // Small delay to prevent race conditions
          }
        }
    
    } catch (error) {
      console.error('Error fetching chat history:', error);
    }
  };

  // Function to open modal when delete is clicked
  const handleOpenDeleteModal = (chatId: string) => {
    setSelectedChatId(chatId);
    setModalOpen(true);
  };

  // Function to confirm delete
  const handleConfirmDelete = async() => {
    handleSelectChat(selectedChatId || '')
    if (selectedChatId) {
      await deleteChat(app_id || '', localStorage.getItem('net_id') || '',selectedChatId);
      // Perform the delete operation (e.g., update state or API call)
      await updateChatHistory(app_id || '', localStorage.getItem('net_id') || '', selectedChatId,'Delete');
     
    }
    setModalOpen(false);
    setTimeout(() => {
      // handleNewChat();
    }, 300); // Small delay to prevent race conditions
    // setSelectedChatId(null);
    // handleNewChat();
  };
  const handleToggleSidebar = () => {
    setIsSidebarOpen(prev => !prev);
  };
  
  const generateDummyUserId = (app_id: any) => {
    const now = new Date();
  
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');
  
    return `user_${app_id}_${year}${month}${day}${hours}${minutes}${seconds}`;
  };
  
  
  

  // Find the active chat based on the activeChatId
  const activeChat = chats.find((chat) => chat.id === activeChatId);
  if(activeChatId === 'chat'){
    let activeChats = chats.find((chat) => chat.id === activeChatId);
    if(!activeChats)
      handleNewChat()
  }
  // if(activeChatId === 'chat'){
  //   let activeChats = chats.find((chat) => chat.id === activeChatId);
  //   if(!activeChats)
  //     handleNewChat()
  // }

  return (
    <div className="flex min-h-screen flex-col">
      {isValidApp === null ? (
         <div className="flex items-center justify-center min-h-screen">
         <div className="spinner-border animate-spin inline-block w-16 h-16 border-4 rounded-full border-t-transparent border-gray-900"></div>
       </div>
      ) : isValidApp ? (
        <div className="flex-1 flex">
          {/* Sidebar Section - Always visible (ChatSidebar handles collapsed/expanded states) */}
          <div className="chat-sidebar transition-all duration-300 h-screen">
           
          <ChatSidebar
            chats={chats}
            onSelectChat={handleSelectChat}
            configData={configData}
            onNewChat={handleNewChat}
            activeChatId={activeChatId ?? '1'}
            toggleSidebar={handleToggleSidebar}
            isSidebarOpen={isSidebarOpen}
            updateChatHistory={updateChatHistory} 
            onDelete={handleOpenDeleteModal }
            isPreview={preview}
            onLogout={handleLogout}
            userMsgCount={userMsgCount}
            bypassMode={bypassMode}
            noAuth={noAuth}
            netId={netId}
            themeOverride={themeOverride}
            setThemeOverride={setThemeOverride}
          />
          </div>

           {/* Topbar with Sidebar Toggle Icon - Responsive to sidebar */}
           <div className="flex-1 flex flex-col">
            <div 
              className="topbar h-[7%] md:h[4%] lg:h-[6%] flex items-center p-4 transition-all duration-300" 
              style={{ 
                backgroundColor: String(configData?.app_ui_settings?.ui_showheader) === 'true' ? configData?.app_ui_settings.ui_headercolor : configData?.app_ui_settings.ui_backgroundcolor,
                marginLeft: isSidebarOpen && window.innerWidth > 768 ? '256px' : (window.innerWidth > 768 ? '52px' : '0')
              }}
            >
              {/* Mobile Sidebar Toggle - Only show on mobile when sidebar is closed */}
              {!isSidebarOpen && window.innerWidth <= 768 && (
                <button onClick={() => setIsSidebarOpen(true)} className="text-xl mr-3">
                  <div
                    className="h-5 w-5 cursor-pointer"
                    style={{ color: configData?.app_ui_settings.ui_backgroundcolor || '#000000' }}
                  >
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-full w-full"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M8.85719 3L13.5 3C14.0523 3 14.5 3.44772 14.5 4C14.5 4.55229 14.0523 5 13.5 5H11.5V19H15.1C16.2366 19 17.0289 18.9992 17.6458 18.9488C18.2509 18.8994 18.5986 18.8072 18.862 18.673C19.4265 18.3854 19.8854 17.9265 20.173 17.362C20.3072 17.0986 20.3994 16.7509 20.4488 16.1458C20.4992 15.5289 20.5 14.7366 20.5 13.6V11.5C20.5 10.9477 20.9477 10.5 21.5 10.5C22.0523 10.5 22.5 10.9477 22.5 11.5V13.6428C22.5 14.7266 22.5 15.6008 22.4422 16.3086C22.3826 17.0375 22.2568 17.6777 21.955 18.27C21.4757 19.2108 20.7108 19.9757 19.77 20.455C19.1777 20.7568 18.5375 20.8826 17.8086 20.9422C17.1008 21 16.2266 21 15.1428 21H8.85717C7.77339 21 6.89925 21 6.19138 20.9422C5.46253 20.8826 4.82234 20.7568 4.23005 20.455C3.28924 19.9757 2.52433 19.2108 2.04497 18.27C1.74318 17.6777 1.61737 17.0375 1.55782 16.3086C1.49998 15.6007 1.49999 14.7266 1.5 13.6428V10.3572C1.49999 9.27341 1.49998 8.39926 1.55782 7.69138C1.61737 6.96253 1.74318 6.32234 2.04497 5.73005C2.52433 4.78924 3.28924 4.02433 4.23005 3.54497C4.82234 3.24318 5.46253 3.11737 6.19138 3.05782C6.89926 2.99998 7.77341 2.99999 8.85719 3ZM9.5 19V5H8.9C7.76339 5 6.97108 5.00078 6.35424 5.05118C5.74907 5.10062 5.40138 5.19279 5.13803 5.32698C4.57354 5.6146 4.1146 6.07354 3.82698 6.63803C3.69279 6.90138 3.60062 7.24907 3.55118 7.85424C3.50078 8.47108 3.5 9.26339 3.5 10.4V13.6C3.5 14.7366 3.50078 15.5289 3.55118 16.1458C3.60062 16.7509 3.69279 17.0986 3.82698 17.362C4.1146 17.9265 4.57354 18.3854 5.13803 18.673C5.40138 18.8072 5.74907 18.8994 6.35424 18.9488C6.97108 18.9992 7.76339 19 8.9 19H9.5ZM5 8.5C5 7.94772 5.44772 7.5 6 7.5H7C7.55229 7.5 8 7.94772 8 8.5C8 9.05229 7.55229 9.5 7 9.5H6C5.44772 9.5 5 9.05229 5 8.5ZM5 12C5 11.4477 5.44772 11 6 11H7C7.55229 11 8 11.4477 8 12C8 12.5523 7.55229 13 7 13H6C5.44772 13 5 12.5523 5 12Z"
                        fill="currentColor"
                      ></path>
                      <circle cx="20" cy="5" r="4" fill="#0285FF"></circle>
                    </svg>
                  </div>
                </button>
              )}
                
                { configData?.app_ui_settings.ui_showheader === "true" && (
                <>
                <div className="flex pl-2">
                    <img
                      src={configData?.app_ui_settings.ui_logo || ""}
                      alt="App Logo"
                      className="h-10 w-auto object-contain"
                    />        
              </div>
              </>
                )}
              

              
              {/* <button onClick={() => setIsSidebarOpen(!isSidebarOpen)} className="text-xl">
                {isSidebarOpen ? 'Hide Sidebar' : 'Show Sidebar'}
              </button> */}
            </div>
          
          {/* Main Chat Container Section */}
          <div className="flex-1 transition-all duration-300">
            {activeChat && (
              <Chat
                configData={configData}
                messages={activeChat.messages}
                activeChatId={activeChatId ?? '1'}
                onSendMessage={handleSendMessage}
                isSidebarOpen={isSidebarOpen}
                pendingMsgCount={pendingMsgCount}
                allowSendMsg={allowSendMsg}
                themeOverride={themeOverride}
              />
            )}
          </div>
        </div>
        </div>
      ) : (
        <NotFound title={errorTitle} message={errorMessage} />
      )}

      {/* Confirmation Modal */}
      <DeleteConfirmationModal
        isOpen={isModalOpen}
        onClose={() => setModalOpen(false)}
        onConfirm={handleConfirmDelete}
        configData = {configData}
        title={chats.find(chat => chat.id === selectedChatId)?.title || 'Chat'}
      />
    </div>
  );
};

export default ChatAssistantWrapper;

